import { BillingGroupModal } from "../BillingGroupModal";
import type { AssignBillingGroupModalProps } from "./types";

export const AssignBillingGroupModal = (props: AssignBillingGroupModalProps) => (
  <BillingGroupModal {...props} mode="assign" />
);
